<div [formGroup]="formGroup()" class="form-container" wnlGroup #wnlGroup="wnlGroup">
    @if (patient().isPediatric()) {
        <p>WNL: Normocephalic, no lesions or scars. PERRLA, sclera white, conjuntiva pink. Symmetrical, no ear discharge,
        hearing intact. No nose discharge noted. Soft, no lymphadenopathy, trachea midline.
        Mucus membranes moist and pink, no lesions, tonsils not enlarged.
        Fontanelles flat and soft and sutures proximal (if applicable), reflexes present.</p>
    }
    @else {
        <p>WNL: Normocephalic, no lesions or scars. PERRLA, sclera white, conjuntiva pink. Symmetrical, no ear discharge,
        hearing intact. No nose discharge noted. Soft, no lymphadenopathy, trachea midline.
        Mucus membranes moist and pink, no lesions, tonsils not enlarged.</p>
    }
    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
        (change)="wnlGroup.setAllWnl($event.checked)"
        [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
        All Within Normal Limits
    </mat-checkbox>

    <div class="head">
        <h2>Head</h2>

        <assessment-row title="Abnormal Shape">
            <emr-input type="text" [control]="formGroup().controls.headAbnormalShape" [wnlControl]="'abnormalShape'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>

        @if (patient().isPediatric()) {
            <assessment-row title="Abnormal Fontanelles">
                <emr-checkbox [control]="formGroup().controls.abnormalFontanelles" label="Yes"
                    [wnlControl]="'abnormalFontanelles'" [wnlDefault]="false" />
            </assessment-row>
            @if (abnormalFontanelles) {
                <assessment-row title="Fontanelles Bulging">
                    <emr-input type="text" [control]="formGroup().controls.fontanelleBulging" />
                </assessment-row>
                <assessment-row title="Fontanelles Sunken">
                    <emr-input type="text" [control]="formGroup().controls.fontanelleSunken" />
                </assessment-row>
                <assessment-row title="Other Fontanelle Abnormality">
                    <emr-input type="text" [control]="formGroup().controls.fontanelleOther" />
                </assessment-row>
            }
            <assessment-row title="Sutures Overriding">
                <emr-checkbox [control]="formGroup().controls.suturesOverriding" label="Yes"
                    [wnlControl]="'suturesOverriding'" [wnlDefault]="false" />
            </assessment-row>
            @if (suturesOverriding) {
                <assessment-row title="Sutures Overriding Details">
                    <emr-input type="text" [control]="formGroup().controls.suturesOverridingDetails" />
                </assessment-row>
            }
        }

        <assessment-row title="Lesions or Scars">
            <emr-input type="text" [control]="formGroup().controls.headLesionsOrScars"
                [wnlControl]="'lesionsOrScars'" [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Other">
            <emr-input type="text" [control]="formGroup().controls.headOther" [wnlControl]="'headOther'"
                [wnlDefault]="''" />
        </assessment-row>
    </div>

    <div class="eyes">
        <h2>Eyes</h2>

        <assessment-row title="Pupillary Response">
            <emr-input type="select" [control]="formGroup().controls.pupillaryResponse"
                [options]="pupillaryResponseOptions" [wnlControl]="'pupillaryResponse'" [wnlDefault]="'WNL'" />
        </assessment-row>

        <h2>Pupillary Dilation</h2>
        <div class="sensation">
            <emr-input type="select" label="Left" [control]="formGroup().controls.leftPupillaryDilation"
                [options]="pupillaryDilationOptions" [bottomSpace]="true" />
            <emr-input type="select" label="Right"
                [control]="formGroup().controls.rightPupillaryDilation" [options]="pupillaryDilationOptions"
                [bottomSpace]="true" />
        </div>

        <assessment-row title="Sclera Yellow?">
            <emr-checkbox [control]="formGroup().controls.scleraYellow" label="Yes" [wnlControl]="'scleraYellow'"
                [wnlDefault]="false" />
        </assessment-row>

        <assessment-row title="Conjunctiva Pale?">
            <emr-checkbox [control]="formGroup().controls.conjunctivaPale" label="Yes"
                [wnlControl]="'conjunctivaPale'" [wnlDefault]="false" />
        </assessment-row>

        <assessment-row title="Conjunctiva Red?">
            <emr-checkbox [control]="formGroup().controls.conjunctivaRed" label="Yes" [wnlControl]="'conjunctivaRed'"
                [wnlDefault]="false" />
        </assessment-row>

        <assessment-row title="Other">
            <emr-input type="text" [control]="formGroup().controls.eyesOther" [wnlControl]="'eyesOther'"
                [wnlDefault]="''" />
        </assessment-row>
    </div>

    <div class="ears">
        <h2>Ears</h2>

        <assessment-row title="Asymmetrical?">
            <emr-checkbox [control]="formGroup().controls.earsAsymmetrical" label="Yes"
                [wnlControl]="'asymmetrical'" [wnlDefault]="false" />
        </assessment-row>

        <assessment-row title="Hearing Impaired">
            <emr-input type="text" [control]="formGroup().controls.hearingImpaired" [wnlControl]="'hearingImpaired'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>
        @if (formGroup().controls.hearingImpaired.enabled) {
        <h2>Hearing Aids</h2>
        <div class="hearingAid">
            <assessment-row title="Left">
                <emr-checkbox [control]="formGroup().controls.hearingAidLeft" label="Yes"></emr-checkbox>
            </assessment-row>
            <assessment-row title="Right">
                <emr-checkbox [control]="formGroup().controls.hearingAidRight" label="Yes"></emr-checkbox>
            </assessment-row>
        </div>
        }

        <assessment-row title="Discharge Present">
            <emr-input type="text" [control]="formGroup().controls.earsDischargePresent"
                [wnlControl]="'earDischargePresent'" [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Other">
            <emr-input type="text" [control]="formGroup().controls.earsOther" [wnlControl]="'earsOther'"
                [wnlDefault]="''" />
        </assessment-row>
    </div>

    <div class="nose">
        <h2>Nose</h2>
        <assessment-row title="Obstructed Nares">
            <emr-input type="text" [control]="formGroup().controls.obstructedNares" [wnlControl]="'obstructedNares'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Discharge Present">
            <emr-input type="text" [control]="formGroup().controls.noseDischargePresent"
                [wnlControl]="'noseDischargePresent'" [wnlDefault]="''"></emr-input>
        </assessment-row>
    </div>

    <div class="neck">
        <h2>Neck</h2>

        <assessment-row title="Firm to Touch">
            <emr-input [control]="formGroup().controls.neckFirmToTouch" [wnlControl]="'firmToTouch'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Stiff Neck">
            <emr-input [control]="formGroup().controls.stiffNeck" [wnlControl]="'stiffNeck'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Enlarged Lymph Nodes">
            <emr-input [control]="formGroup().controls.enlargedLymphNodes" [wnlControl]="'enlargedLymphNodes'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Deviated Trachea">
            <emr-input [control]="formGroup().controls.deviatedTrachea" [wnlControl]="'deviatedTrachea'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>
    </div>

    <div class="throat">
        <h2>Throat/Mouth</h2>

        <assessment-row title="Dry Mucus Membranes">
            <emr-checkbox [control]="formGroup().controls.throatDryMucusMembranes" label="Yes"
                [wnlControl]="'dryMucusMembranes'" [wnlDefault]="false" />
        </assessment-row>

        <assessment-row title="Lesions Present">
            <emr-input [control]="formGroup().controls.throatLesionsPresent" [wnlControl]="'lesionsPresent'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>

        <assessment-row title="Enlarged Tonsils">
            <emr-input [control]="formGroup().controls.enlargedTonsils" [wnlControl]="'enlargedTonsils'"
                [wnlDefault]="''"></emr-input>
        </assessment-row>
    </div>

    <assessment-row title="Other Findings">
        <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
            [wnlDefault]="''" />
    </assessment-row>
</div>